function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7.12305C10.3175 7.12305 8.94851 8.49193 8.94851 10.1745C8.94851 11.8571 10.3175 13.226 12 13.226C13.6826 13.226 15.0516 11.8571 15.0516 10.1745C15.0516 8.49193 13.6826 7.12305 12 7.12305ZM12 12.4052C10.77 12.4052 9.76928 11.4045 9.76928 10.1745C9.76928 8.94445 10.77 7.94382 12 7.94382C13.2301 7.94382 14.2308 8.94451 14.2308 10.1745C14.2308 11.4045 13.2301 12.4052 12 12.4052Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 5C9.14682 5 6.82556 7.32126 6.82556 10.1745C6.82556 11.82 8.20556 14.2715 9.02814 15.5863C9.56935 16.4514 10.151 17.2747 10.6657 17.9045C11.492 18.9154 11.7878 18.9999 12.0001 18.9999C12.2156 18.9999 12.4948 18.9153 13.3185 17.9039C13.8345 17.2703 14.4164 16.4475 14.957 15.587C15.7852 14.2689 17.1746 11.813 17.1746 10.1744C17.1746 7.32126 14.8533 5 12.0001 5ZM14.388 14.9479C13.3267 16.6706 12.3523 17.8347 11.9952 18.1319C11.6362 17.8439 10.6776 16.7075 9.60147 14.9534C8.35899 12.928 7.64639 11.1861 7.64639 10.1745C7.64634 7.77383 9.5994 5.82077 12.0001 5.82077C14.4007 5.82077 16.3538 7.77383 16.3538 10.1745C16.3538 11.1803 15.6373 12.9201 14.388 14.9479Z",
  fill: "currentColor"
});

var SvgMapMarkerAlt = function SvgMapMarkerAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapMarkerAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-marker-alt.3afdf82c.svg";
export { ForwardRef as ReactComponent };